<template>
  <div class="navigationSeventh">
    <div class="navigationSevenths">
      <div class="nav">
        <div class="nav_t">
          <div class="nav_l">
            <span>{{ currentDate }}</span>
            <span class="q">用心 · 用情 · 用力做教育!</span>
          </div>
          <div class="nav_r"><span style="font-family: MiSans, MiSans;">24</span> 小时热线：<span style="font-family: MiSans, MiSans;">{{ domainInfo.mobile }}</span></div>
        </div>
        <div class="b">
          <div class="l">
            <img style=" height: 68px;" :src="logo" />

          </div>
          <div class="r">
            <div @click="goNext('/')">首页
              <div v-if="activeIndex == '/'" class="line"></div>
            </div>
            <div @mouseenter="showDrop($event, 1)" @mouseleave="showDrop($event, 1)" class="dropdown-menu-item">
              <div @click="goNext('/xqxx?uName=学校概况')">学校概况
                <div v-if="showDropdown" class="dropdown-content" @mouseenter="showDrop($event, 1)"
                  @mouseleave="showDrop($event, 1)">
                  <div @click.stop="goNext('/xqxx?uName=学校概况&dname=学校介绍')">学校介绍</div>
                  <div @click.stop="goNext('/xqxx?uName=学校概况&dname=基地介绍')">基地介绍</div>
                  <div @click.stop="goNext('/xqxx?uName=学校概况&dname=校园风光')">校园风光</div>
                </div>
                <div v-if="activeIndex == '/xqxx' && uName == '学校概况'" class="line"></div>
              </div>
            </div>
            <div @click="goNext('/xqxx?uName=招生简章')">招生简章<div v-if="activeIndex == '/xqxx' && uName == '招生简章'"
                class="line">
              </div>
            </div>
            <div @mouseenter="showDrop1($event, 1)" @mouseleave="showDrop1($event, 1)" class="dropdown-menu-item" @click="goNext('/xqxx?uName=项目介绍')">项目介绍
              <div v-if="showDropdown1" class="dropdown-content" @mouseenter="showDrop1($event, 1)"
                  @mouseleave="showDrop1($event, 1)">
                  <div @click.stop="goNext('/xqxx?uName=项目介绍&dname=项目背景')">项目背景</div>
                  <div @click.stop="goNext('/xqxx?uName=项目介绍&dname=项目简介')">项目简介</div>
                  <div @click.stop="goNext('/xqxx?uName=项目介绍&dname=办学优势')">办学优势</div>
                </div>
              <div v-if="activeIndex == '/xqxx' && uName == '项目介绍'"
                class="line">
              </div>
            </div>
            <div @click="goNext('/zyxx?uName=专业设置')">专业设置<div v-if="activeIndex == '/zyxx'" class="line"></div>
            </div>
            <div @click="goNext('/xqvip')">在线学习<div v-if="activeIndex == '/xqvip'" class="line"></div>
            </div>
            <div @mouseenter="showDrop2($event, 1)" @mouseleave="showDrop2($event, 1)" class="dropdown-menu-item" @click="goNext('/xqxx?uName=报考指南')">报考指南
                 <div v-if="showDropdown2" class="dropdown-content" @mouseenter="showDrop2($event, 1)"
                  @mouseleave="showDrop2($event, 1)">
                  <div @click.stop="goNext('/xqxx?uName=报考指南&dname=报名流程')">报名流程</div>
                  <div @click.stop="goNext('/xqxx?uName=报考指南&dname=招生问答')">招生问答</div>
                  <div @click.stop="goNext('/cqcx')">录取查询</div>
                </div>
              <div v-if="activeIndex == '/xqxx' && uName == '报考指南'"
                class="line">
              </div>
            </div>
            <div @click="goNext('/bm')">网上报名<div v-if="activeIndex == '/bm'" class="line"></div>
            </div>
            <div @click="goNext('/xqlx')">联系我们<div v-if="activeIndex == '/xqlx'" class="line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginOut } from "@/api/user";
import { Know } from "@/api/know";

const know = new Know();
import Bus from "@/api/bus";
import Vue from "vue";
import {
  setReady,
  getToken,
  getInfo,
  getDomainLogo,
  getDomain,
} from "@/api/cookies";
export default {
  components: {},
  data() {
    return {
      showDropdown: false,
      showDropdown1: false,
      showDropdown2: false,
      userInfo: null,
      debounceTimer: null,
      debounceTimer1: null,
      debounceTimer2: null,
      activeIndex: '/',
      uName: ''

    };
  },
  watch: {
    // 使用这个可以监听data中指定数据的变化,然后触发watch中对应的function的处理
    $route: function (newVal, oldVal) {
      console.log(newVal.path, 'newVal.path');
      console.log(newVal, 'newVal');
      this.activeIndex = newVal.path;
      this.uName = newVal.query.uName;

    },
  },
  async created() {
    this.userInfo = getInfo();
    this.domainInfo = getDomain();
    this.logo = getDomainLogo();
    this.userId = localStorage.getItem("userId");
    this.token = getToken();
    this.userInfos = getInfo();
    this.getTodayDate();

  },

  methods: {
    showDrop(e) {
      if (e.type === 'mouseenter') {
        const currentTime = Date.now();
        // 检查是否在 mouseleave 后 1 秒内触发 mouseenter
        if (currentTime - this.lastLeaveTime <= 1000) {
          this.showDropdown = true;
        } else {
          this.showDropdown = true;
        }
        clearTimeout(this.debounceTimer);
      } else if (e.type === 'mouseleave') {
        this.lastLeaveTime = Date.now(); // 记录 mouseleave 触发时间
        this.debounceTimer = setTimeout(() => {
          this.showDropdown = false;
        }, 500);
      }
    },
     showDrop1(e) {
      if (e.type === 'mouseenter') {
        const currentTime = Date.now();
        // 检查是否在 mouseleave 后 1 秒内触发 mouseenter
        if (currentTime - this.lastLeaveTime <= 1000) {
          this.showDropdown1 = true;
        } else {
          this.showDropdown1 = true;
        }
        clearTimeout(this.debounceTimer1);
      } else if (e.type === 'mouseleave') {
        this.lastLeaveTime = Date.now(); // 记录 mouseleave 触发时间
        this.debounceTimer1 = setTimeout(() => {
          this.showDropdown1 = false;
        }, 500);
      }
    },
     showDrop2(e) {
      if (e.type === 'mouseenter') {
        const currentTime = Date.now();
        // 检查是否在 mouseleave 后 1 秒内触发 mouseenter
        if (currentTime - this.lastLeaveTime <= 1000) {
          this.showDropdown2 = true;
        } else {
          this.showDropdown2 = true;
        }
        clearTimeout(this.debounceTimer2);
      } else if (e.type === 'mouseleave') {
        this.lastLeaveTime = Date.now(); // 记录 mouseleave 触发时间
        this.debounceTimer2 = setTimeout(() => {
          this.showDropdown2 = false;
        }, 500);
      }
    },
    getTodayDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      // 拼接年月日
      this.currentDate = `${year}-${month}-${day}`;
    },
    open() {
      window.open("http://gxhh.unzs.com", "_blank");
    },

    /* 菜单切换 */
    handleSelect(key, keyPath) {
      if (key == "/0" || key == "/1" || key == "/2") {
        return;
      }
      const userInfo = getInfo();
      for (const item of this.data.chil) {
        if (key == item.path) {
          this.data.name = item.name;
          this.data.path = item.path;
          break;
        }
      }
      if (
        !userInfo &&
        (key == "/partnerPage/my/myInfo" || key == "/partnerPage/mycurriculum")
      ) {
        this.$notify({
          title: "提醒",
          message: "请您先登录~",
          offset: 100,
        });
        // Vue.prototype.goLoginView(false)
        return;
      }

      const routeUrl = this.$router.resolve({
        path: key,
      });
      window.open(key, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.navigationSeventh {
  position: relative;
  height: 133px;

  .navigationSevenths {
    width: 100%;
    height: 133px;
    background: linear-gradient(90deg, #0073ff 0%, #0057c9 100%);
    border-radius: 0px 0px 0px 0px;
    position: fixed;
    z-index: 9999;
    padding: 15px 0;

    .nav {
      width: 1400px;
      margin: 0 auto;

      .nav_t {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .nav_l {
          span {
            font-family: MiSans, MiSans;
            font-weight: 500;
            font-size: 13px;
            color: #FFFFFF;
          }

          .q {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 13px;
            color: #FFFFFF;
            margin-left: 16px;
          }
        }

        .nav_r {
          // font-family: MiSans, MiSans;
          font-weight: 500;
          font-size: 14px;
          color: #FFFFFF;
        }
      }

      .b {
        margin-top: 15px;
        height: 68px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .l {
          width: 453px;
          height: 68px;
          overflow: hidden;
          border-radius: 0px 0px 0px 0px;
        }

        .r {
          width: 850px;
          display: flex;
          align-items: center;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 16px;
          color: #FFFFFF;

          >div {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 30px;
            cursor: pointer;


            .line {
              position: absolute;
              bottom: -6px;
              width: 20px;
              height: 4px;
              background: #FFFFFF;
              border-radius: 3px 3px 3px 3px;
              left: 50%;
              transform: translateX(-50%);
            }

            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}

.dropdown-menu-item {
  position: relative;
  cursor: pointer;
  padding: 0 10px;
  color: #FFFFFF;
  user-select: none;
}

.dropdown-content {
  position: absolute;
  top: calc(100% + 10px);

  /* 紧贴菜单项下方 */
  left: 50%;
  transform: translateX(-50%);

  width: 144px;
  background: #fff;
  border-radius: 8px;
  z-index: 10000;

  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  overflow: hidden;


  div {

    padding: 14px 0;
    text-align: center;
    cursor: pointer;

    &:hover {
      background: linear-gradient(90deg, #0073FF 0%, #0057C9 100%);
      color: #fff;
    }
  }
}
</style>
